import { AnnouncementReaction } from '../../announcement'
import { AwardEndorsement, AwardReaction } from '../../award'
import { Comment, CommentEmbeds } from '../../comment/types'
import { TenantMemberDisplayData } from '../../identity'
import { MediaObjectUrl } from '../../media'
import {
  RecognitionEndorsement,
  RecognitionReaction,
  RecognitionRecipients,
} from '../../recognition'
import { PageResult, PaginatedSearch, WithPermissions } from '../types'

/** Shared properties for wall posts (recognition, award, etc.) */
export enum ReactionValue {
  LOVE = 'love',
  ONE_HUNDRED = '100',
  CLAP = 'clap',
  FIRE = 'fire',
}

export type Reaction = RecognitionReaction | AwardReaction | AnnouncementReaction

export type Endorsement = RecognitionEndorsement | AwardEndorsement

export type WallPost = WithPermissions<{
  id: string
  tenantId: string
  senderId: string
  message: string
  mentionIds: string[]
  amount: number
  gifs: string[]
  publishedAt: string | null
  createdAt: string
  updatedAt: string
  // Embeds
  sendTo?: RecognitionRecipients[]
  sender?: TenantMemberDisplayData
  delegate?: TenantMemberDisplayData
  comments?: PageResult<Comment>
  attachmentUrls?: MediaObjectUrl[]
  endorsementStats?: EndorsementStats
  reactionCounts?: ReactionCount[]
}>

export type EndorsementsEmbeds = 'members'

export type CreateEndorsementParams = {
  id: string
  amount: number
}

export type EndorsementStats = {
  total: number
  amount: number
  ownAmount: number | null
}

export type ListEndorsementsParams = PaginatedSearch<object, EndorsementsEmbeds>

export type CreateCommentParams = {
  body: string
  id: string
  tenantMemberId: string
  threadId: string
  gifs?: string[]
}

export type ReactionsEmbeds = 'members'

export type ListReactionsParams = PaginatedSearch<
  {
    reactionIn: ReactionValue[]
  },
  ReactionsEmbeds
>

export type ReactionCount = {
  ownReaction: boolean
  reaction: ReactionValue
  total: number
}

export type CreateReactionParams = {
  reaction: ReactionValue
  postId: string
  commentId?: string
}

export type GetCommentsParams = PaginatedSearch<{
  embeds: CommentEmbeds[]
}>

export type ListCommentsReactionsParams = PaginatedSearch<
  {
    reactionIn: ReactionValue[]
  },
  ReactionsEmbeds
>

export type CountResponse = {
  total: number
}

export type FlagParams = {
  postId: string
}

export type UpdateWallPostMessageParams = {
  message: string
  qualityIds?: string[]
  gifs?: string[]
  attachments?: string[]
  tenantWide?: boolean
}

export type UpdateWallPostCommentParams = {
  body: string
  gifs?: string[]
}

export enum WallPostTypeEnum {
  AWARD = 'award',
  RECOGNITION = 'recognition',
}
